<template>
  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="6"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              {{ lotDetail.lotNo }}
            </h1>
            <p class="log_info">
              Created by {{ getCreatedBy() }} on {{ getCreatedAt() }} <br>Last updated on {{ getUpdatedAt() }}
            </p>
          </b-col>
        </b-row>
      </b-col>

      <b-col
        class="content-header-right text-md-right d-md-block d-none mb-1"
        md="6"
        cols="12"
      >
        <div class="user_block pr_stage_type">
          <div class="user_avatar" />
          <div class="user_info">
            <h6>Lot Status</h6>
            <h5 :class="`text-${resolveStatusVariant(lotDetail.nvsStatus)}`">
              {{ lotDetail.nvsStatus }}
            </h5>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-card
          header-tag="header"
          class=""
        >
          <div class="d-flex justify-content-between">
            <b-table-simple
              borderless
              responsive
              class="custom-th-width"
            >
              <b-tbody>
                <b-tr>
                  <b-th width="230">
                    Suite ID
                  </b-th>
                  <b-td class="mt-50">
                    {{ lotDetail.suite ? lotDetail.suite.stringID : '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Suite No.
                  </b-th>
                  <b-td class="mt-50">
                    {{ lotDetail.suite ? lotDetail.suite.code : '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Product Type
                  </b-th>
                  <b-td class="mt-50">
                    {{ lotDetail.productType || '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Zone No.
                  </b-th>
                  <b-td class="mt-50">
                    {{ lotDetail.zoneNo || '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Lot No.
                  </b-th>
                  <b-td class="mt-50">
                    {{ lotDetail.lotNo || '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Lot Type
                  </b-th>
                  <b-td class="mt-50">
                    {{ lotDetail.lotType || '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Bury Capacity
                  </b-th>
                  <b-td class="mt-50">
                    {{ lotDetail.buryCapacity || '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Area Length
                  </b-th>
                  <b-td class="mt-50">
                    {{ lotDetail.size || '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Level No.
                  </b-th>
                  <b-td class="mt-50">
                    {{ lotDetail.levelNo || '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Direction
                  </b-th>
                  <b-td class="mt-50">
                    {{ lotDetail.direction || '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Interment Date
                  </b-th>
                  <b-td class="mt-50">
                    {{ lotDetail.intermentDate ? dateFormatWithTime(lotDetail.intermentDate) : '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Maintenance Fee
                  </b-th>
                  <b-td class="mt-50">
                    {{ getMaintenanceFee() }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    PV
                  </b-th>
                  <b-td class="mt-50">
                    {{ getPVPrice() }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BTableSimple, BTbody, BTr, BTd, BTh,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import store from '@/store/index'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTableSimple,
    BTbody,
    BTh,
    BTr,
    BTd,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      lotDetail: {},
      status: 'published',
      statusValidation: false,
      statusError: 'Valid status is required',
      reservableOptions: [
        { title: 'Staff-only', code: 'Staff-only' },
        { title: 'Not for reservation', code: 'Not for reservation' },
        { title: 'All agents & Staff', code: 'All agents & Staff' },
      ],
      saleStatusOptions: [
        { title: 'Open Sales', code: 'Open Sales' },
        { title: 'Not for sale', code: 'Not for sale' },
        { title: 'Only from reservations', code: 'Only from reservations' },
      ],
      reservableStatus: 'Staff-only',
      saleStatusValue: 'Not for sale',
      required,
    }
  },
  created() {
    this.$http.get(`reservation/lots/${this.$route.params.id}/show`)
      .then(response => {
        this.lotDetail = response.data

        store.commit('breadcrumb/REMOVE_BREADCRUMB')
        const newMeta = {
          text: `${this.lotDetail.suite ? this.lotDetail.suite.code : ''} - ${this.lotDetail.suite ? this.lotDetail.suite.name : ''}`,
          to: `/products/suites/${this.lotDetail.suite ? this.lotDetail.suite._id : ''}/show`,
        }
        store.commit('breadcrumb/UPDATE_BREADCRUMB', newMeta)
        const secondMeta = {
          active: true,
          text: `${this.lotDetail.lotNo || ''}`,
        }
        store.commit('breadcrumb/UPDATE_BREADCRUMB', secondMeta)
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  methods: {
    // resolveStatusVariant(status) {
    //   if (status === 'CONFIRM') return 'success'
    //   if (status === 'OPEN') return 'secondary'
    //   if (status === 'RESERVE') return 'warning'
    //   if (status === 'BOOK') return 'warning'
    //   if (status === 'HOLD') return 'danger'
    //   return 'primary'
    // },
    resolveStatusVariant(status) {
      if (status === 'Confirmed') return 'success'
      if (status === 'Available') return 'secondary'
      if (status === 'Reserved') return 'warning'
      if (status === 'Booked') return 'warning'
      if (status === 'Occupied') return 'danger'
      return 'primary'
    },
    resolveStatus(status) {
      if (status === 'CONFIRM') return 'Confirmed'
      if (status === 'OPEN') return 'Available'
      if (status === 'RESERVE') return 'Reserved'
      if (status === 'BOOK') return 'Booked'
      if (status === 'HOLD') return 'Occupied'
      return '-'
    },
    getCreatedBy() {
      if (this.lotDetail.createdByNvs) {
        return this.lotDetail.createdByNvs.name
      }
      if (this.lotDetail.createdBy) {
        return this.lotDetail.createdBy
      }

      return ''
    },
    getCreatedAt() {
      if (this.lotDetail.createdAtNvs) {
        return this.dateFormatWithTime(this.lotDetail.createdAtNvs)
      }
      if (this.lotDetail.createdAt) {
        return this.dateFormatWithFormatNTZ(this.lotDetail.createdAt, 'DD/MM/YYYY, hh:mma ')
      }

      return ''
    },
    getUpdatedAt() {
      if (this.lotDetail.updatedAtNvs) {
        return this.dateFormatWithTime(this.lotDetail.updatedAtNvs)
      }
      if (this.lotDetail.updatedAt) {
        return this.dateFormatWithFormatNTZ(this.lotDetail.updatedAt, 'DD/MM/YYYY, hh:mma ')
      }

      return ''
    },
    getMaintenanceFee() {
      if (this.lotDetail.dspItems && this.lotDetail.dspItems.length) {
        const maintenanceObject = this.lotDetail.dspItems.find(item => item.logicCode === 'MAINTENANCE')
        return maintenanceObject ? `$${this.numberFormat(maintenanceObject.price)}` : '-'
      }

      return '-'
    },
    getPVPrice() {
      if (this.lotDetail.dspItems && this.lotDetail.dspItems.length) {
        const mainProductObject = this.lotDetail.dspItems.find(item => item.logicCode === 'MAINPRODUCT')
        return mainProductObject ? `$${this.numberFormat(mainProductObject.pv)}` : '-'
      }

      return '-'
    },
    submitReservableForm() {
      this.$refs.reservableEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('status', this.reservableStatus)

          this.$http.patch(`reservation/suites/${this.$route.params.id}/reservable/update`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(() => {
              this.lotDetail.reservableBy = this.reservableStatus

              this.$swal({
                title: 'Status Updated!',
                html: 'The status for this suite reservable by has been updated',
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/save.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            })
        }
      })
    },

    submitSaleStatusForm() {
      this.$refs.saleStatusEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('status', this.saleStatusValue)

          this.$http.patch(`reservation/suites/${this.$route.params.id}/sale-status/update`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(() => {
              this.lotDetail.saleStatus = this.saleStatusValue

              this.$swal({
                title: 'Status Updated!',
                html: 'The sale status for this suite has been updated',
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/save.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            })
        }
      })
    },
  },
}
</script>

  <style lang="scss">
    .item-field-custom-class {
      color: #000000;
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
    }
    .display-content {
      display: contents;
    }
    .custom-th-width {
      .table th {
          padding: 0.72rem 2rem 0.72rem 0.72rem;
      }
    }
  </style>
